<div class="cb-layout-item" [ngClass]="['cb-'+type()]">
    @if(before()){
    <ng-container *ngTemplateOutlet="before()!"></ng-container>
    }
    @switch (true) {
    @case (type() === 'title'){
    @if(icon()){
    <cb-icon [name]="icon()"></cb-icon>
    }
    <div class="cb-layout-title-container">
        <div class="cb-layout-title">
            @if(hierarchy() === 'primary'){
            <h1>{{title()}}</h1>
            }@else if(hierarchy() === 'secondary'){
            <h3>{{title()}}</h3>
            }
        </div>
        @if(subtitle()){
        <div class="cb-layout-subtitle">
            <p>{{subtitle()}}</p>
        </div>
        }
    </div>
    }
    @case (type() === 'tabs'){
    <ng-content select="cb-tabs"></ng-content>
    }
    @case(type() === 'global-controls'){
    <div *cbGlobalTemplateHost="globalControlsKey"></div>
    }
    @case (['custom', 'controls', 'filters'].includes(type())) {
    <ng-content></ng-content>
    }
    }
    @if(after()){
    <ng-container *ngTemplateOutlet="after()!"></ng-container>
    }
</div>